/* Ashby: hero text link (Chimi style) — "Back to Office Collection", left-aligned, soft, no dot.
   Also hides itself when the burger drawer is open (it bleeds through the fixed drawer). */
(function () {
  'use strict';

  function injectStyle() {
    if (document.getElementById('ashby-hero-cta-style')) return;
    var s = document.createElement('style');
    s.id = 'ashby-hero-cta-style';
    s.textContent =
      'body:has(.menu-drawer-container[open]) .ashby-hero-cta,' +
      'body:has(.menu-drawer-container.menu-open) .ashby-hero-cta,' +
      'body.menu-open .ashby-hero-cta {' +
      'display:none !important;visibility:hidden !important;opacity:0 !important;pointer-events:none !important;}';
    document.head.appendChild(s);
  }

  function injectHeroCTA() {
    injectStyle();

    var main = document.querySelector('main[data-template="index"]');
    if (!main) return;

    var hero = main.querySelector('.hero, .hero__container');
    if (!hero) return;
    if (hero.querySelector('.ashby-hero-cta')) return;

    var cta = document.createElement('a');
    cta.href = '/collections/back-to-office';
    cta.className = 'ashby-hero-cta';
    cta.setAttribute('aria-label', 'Back to Office Collection');
    cta.style.cssText = [
      'position:absolute',
      'top:58%',
      'left:14px',
      'transform:translateY(-50%)',
      'display:inline-flex',
      'align-items:center',
      "font-family:var(--font-body--family),'Inter',sans-serif",
      'font-size:13px',
      'font-weight:400',
      'letter-spacing:0.01em',
      'color:rgba(255,255,255,0.72)',
      'text-decoration:none',
      'text-shadow:0 1px 3px rgba(0,0,0,0.3)',
      'white-space:nowrap',
      'z-index:50',
      'pointer-events:auto'
    ].join(';');
    cta.textContent = 'Back to Office Collection';

    if (getComputedStyle(hero).position === 'static') {
      hero.style.position = 'relative';
    }

    hero.appendChild(cta);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectHeroCTA);
  } else {
    injectHeroCTA();
  }

  document.addEventListener('shopify:section:load', injectHeroCTA);
})();


/* Ashby: Blaulichtfilter-Tag (frosted glass) — auf allen Optical/Blaulicht-PDPs, oben links im Bild.
   Desktop: ein Badge auf dem ersten (obersten) Bild.
   Mobil (<=749px): EIN fixierter Badge am Galerie-Container — bleibt an seiner Stelle beim Durchsliden. */
(function () {
  'use strict';
  var OPTICAL = ['bale-01','bale-02','bale-03','blake-03','blake-04','cole-03','kent-04','kent-05'];
  var m = location.pathname.match(/\/products\/([^\/?#]+)/);
  if (!m || OPTICAL.indexOf(m[1]) === -1) return;

  var MQ = window.matchMedia('(max-width:749px)');

  function injectBadgeStyle() {
    if (document.getElementById('ashby-blf-style')) return;
    var s = document.createElement('style');
    s.id = 'ashby-blf-style';
    s.textContent =
      '.ashby-blf-badge{position:absolute;top:14px;left:14px;z-index:6;display:inline-flex;align-items:center;padding:4px 9px;font-family:Inter,sans-serif;font-size:10px;font-weight:500;letter-spacing:0.02em;line-height:1;color:rgba(20,20,20,0.82);background:rgba(255,255,255,0.30);-webkit-backdrop-filter:blur(12px) saturate(140%);backdrop-filter:blur(12px) saturate(140%);border:1px solid rgba(255,255,255,0.5);border-radius:2px;box-shadow:0 1px 5px rgba(0,0,0,0.06);pointer-events:none;opacity:0;transform:translateY(-2px);transition:opacity .45s ease,transform .45s ease;}' +
      '.ashby-blf-badge.is-in{opacity:1;transform:translateY(0);}' +
      '@media screen and (max-width:749px){.ashby-blf-badge{top:11px;left:11px;font-size:9px;padding:3px 8px;}}';
    document.head.appendChild(s);
  }

  function firstDesktopFrame(media) {
    var frame = null;
    var imgs = [].slice.call(media.querySelectorAll('img'));
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].getBoundingClientRect().width < 100) continue;
      var f = imgs[i].closest('.product-media-constraint-wrapper') || imgs[i].closest('.product-media');
      if (f && !f.closest('[class*="thumb"]')) { frame = f; break; }
    }
    return frame;
  }

  function ensureBadge() {
    var media = document.querySelector('.product-information__media');
    if (!media) return false;
    var target = MQ.matches ? media : firstDesktopFrame(media);
    if (!target) return false;
    injectBadgeStyle();
    /* remove any badge that is not the current single target */
    [].slice.call(media.querySelectorAll('.ashby-blf-badge')).forEach(function (b) {
      if (b.parentElement !== target) b.remove();
    });
    if (getComputedStyle(target).position === 'static') target.style.position = 'relative';
    var existing = target.querySelector(':scope > .ashby-blf-badge');
    if (!existing) {
      var b = document.createElement('div');
      b.className = 'ashby-blf-badge';
      b.textContent = 'Blaulichtfilter';
      target.appendChild(b);
      requestAnimationFrame(function () { requestAnimationFrame(function () { b.classList.add('is-in'); }); });
    }
    return true;
  }

  function init() {
    ensureBadge();
    var n = 0;
    var t = setInterval(function () { ensureBadge(); if (++n > 20) clearInterval(t); }, 250);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  if (MQ.addEventListener) MQ.addEventListener('change', ensureBadge);
  else if (MQ.addListener) MQ.addListener(ensureBadge);
})();
